// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".period-switcher[data-v-b3e88336]{max-width:150px;min-width:150px}.title-and-switcher-container[data-v-b3e88336]{padding:0 30px}", ""]);
// Exports
module.exports = exports;
